export function absoluteValue(
  value: number
): number {
  return Math.abs(value);
}
